<template>
  <div ref="gannt_wrapper" class="px-1">
    <h3>{{title}} - {{dataGridSource}} </h3>
    <div class="mb-3 d-flex justify-content-end">
      <b-button
        variant="primary"
        size="sm"
        @click="editOptions"
      >
        <icon name="cog"/>
        <span>Edit Options</span>
      </b-button>
    </div>
    <div class="mb-3">
      <button @click="scale ='Quater Day'" class="btn btn-primary btn-sm">Quater Day</button>
      <button @click="scale ='Half Day'" class="btn btn-primary btn-sm">Half Day</button>
      <button @click="scale ='Day'" class="btn btn-primary btn-sm">Day</button>
      <button @click="scale ='Week'" class="btn btn-primary btn-sm">Week</button>
      <button @click="scale ='Month'" class="btn btn-primary btn-sm">Month</button>
    </div>
    <GanttWrapper
      :scale="scale"
      :toggler="toggler"
      :tasks="tasks"
      :source="dataGridSource"
      :storage="storageType"
      @unwatch="dropWatcher"
      @watch="selectSourceToWatch"
    >
    </GanttWrapper>
    <EditGanntChartModal @hide="show = false" v-if="show" ref="editModal" :source="dataGridSource" :ganttId="chartId"
                         @updated="updatedData" :cols="cols"></EditGanntChartModal>
  </div>
</template>

<style>
</style>

<script>
  import EditGanntChartModal from './modals/EditGanntChartModal'
  import {mapState} from 'vuex'
  import db from '@/services/db'
  import GanttWrapper from './GanttWrapper.vue'
  // just helper to get current dates

  let taskSchema = {
    id: 'number',
    label: 'string',
    user: 'string',
    // parentId: 'number',
    start: 'number',
    duration: 'number',
    percent: 'number',
    type: 'string',
  }
  let taskDefault = {
    label: 'No Label',
    user: 'No User',
    start: Date.now(),
    duration: 8,
    percent: 0,
    type: 'task',
  }

  export default {
    name: 'Gantt',
    components: {
      EditGanntChartModal,
      GanttWrapper
    },
    props: ['chartId'],
    data () {
      return {
        show: false,
        tasks: [],
        scale: '',
        toggler: false,
        title: '',
        cols: [],
        dataGridSource: '',
        storageType: '',
        unwatch: () => {
        }
      }
    },
    computed: {
      ...mapState([
        'dataGrid_options',
        'fbUserModels',
        'models_dashboardModel',
        'fbWorkspaceData'
      ]),
    },
    methods: {
      updatedData (value) {
        if (!value) {
          this.unwatch()
          this.selectSourceToWatch()
        }
      },
      dropWatcher() {
        this.unwatch()
      },
      parseTasks (data) {
        this.tasks = []
        const tasks = []
        data.forEach(item => {
          const task = {}
          Object.keys(taskSchema).forEach(el => {
            const taskItem = item[el.toLowerCase()]
            if (taskItem && taskItem.value) {
              if (taskSchema[el] !== typeof taskItem.value) {
                task[el] = typeof taskItem.value === 'number' ? taskItem.value.toString() : +taskItem.value
              } else {
                task[el] = taskItem.value
              }
            }
          })
          if (isNaN(task.id)) {
            delete task.id
          }

          if (isNaN(task.duration) || task.duration < 0 || task.duration > 8760) {
            delete task.duration
          } else {
            task.duration = task.duration * 60 * 60 * 1000
          }

          if (task.type !== 'task' && task.type !== 'milestone' && task.type !== 'project') {
            delete task.type
          }

          if (isNaN(task.percent) || task.percent < 0) {
            delete task.percent
          } else if (task.percent > 100) {
            task.percent = 100
          }

          tasks.push({
            rowId : item.rowId,
            startCell: item.startCell,
            durationCell: item.durationCell,
            percentCell: item.percentCell,
            id: tasks.length + 1,
            ...taskDefault,
            ...task
          })
        })
        if (tasks.length) {
          this.tasks = tasks
        }
      },
      mapData (data, cols) {
        const rows = Object.keys(data)
        return Object.values(data).map((el, idx) => {
          return {
            id: el[cols.id],
            start: el[cols.start],
            label: el[cols.label],
            user: el[cols.user],
            duration: el[cols.duration],
            percent: el[cols.percent],
            type: el[cols.type],
            rowId : rows[idx],
            startCell: cols.start,
            durationCell: cols.duration,
            percentCell: cols.percent
          }
        })
      },
      editOptions () {
        this.show = true
        this.$nextTick(() => {
          this.$refs.editModal.open()
        })
      },
      optionsUpdate (options) {
        this.options = options
      },
      selectSourceToWatch () {
        const source = this.dataGrid_options[this.dataGridSource]
        this.storageType = source.storageType
        switch (source.storageType) {
          case 'user':
            this.model = `fbUserModels.${source.source}`
            break
          case 'dashboard':
            this.model = `models_dashboardModel.${source.source}`
            break
          case 'workspace':
            this.model = `fbWorkspaceData.${source.source}`
            break
        }
        this.unwatch = this.$watch(this.model, () => {
          this.initialize()
        })
      },
      initialize () {
       // console.log('kekos')
        this.toggler = !this.toggler
        let dataGrid
        let columns
        db.gantt.readOptions(this.chartId, (value) => {
          this.cols = value
          dataGrid = value.dataGrid
          this.dataGridSource = dataGrid
          this.title = value.title
        })
        if (dataGrid) {
          db.dataGrid.data.getOptions(dataGrid, (err, options) => {
            if (err) {
              console.error(err)
            }
            const getModel = db.dataGrid.data.getReadModel(options.storageType)
            const data = getModel(options.source)
            if (data && Object.values(data).length) {
              const mappedData = this.mapData(data, this.cols)
              this.parseTasks(mappedData)
            }
          })
        }
      }
    },
    mounted () {
      //console.log('hey')
      this.initialize()
      this.selectSourceToWatch()
    }
  }
</script>
<style scoped lang="scss">
</style>
